// extracted by mini-css-extract-plugin
export default {"info":"tweet-info_info__6C+2X","infoLink":"tweet-info_infoLink__tc9jC","infoIcon":"tweet-info_infoIcon__CbcG8"};